import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {QualityAgent} from '~components/quality-agent/QualityAgent';

export const Route = createFileRoute('/quality-agent')({
  component: QualityAgentPage,
});

function QualityAgentPage(): JSX.Element {
  return (
    <BaseLayout>
      <QualityAgent />
    </BaseLayout>
  );
}
